import axios, { AxiosError } from 'axios';

import { msalInstance, scopes } from '@auth/authConfig';

const baseURL = import.meta.env.VITE_BASE_URL;

if (!baseURL) {
    throw new Error('VITE_API_URL is not defined in .env');
}

const apiClient = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];

        if (!account) {
            console.warn('There is no active account');
            return config;
        }

        try {
            const response = await msalInstance.acquireTokenSilent({
                scopes,
                account,
            });
            config.headers.Authorization = `Bearer ${response.accessToken}`;
        } catch (error) {
            console.error('Error acquiring token silently:', error);
        }

        return config;
    },
    (error) => Promise.reject(error)
);

interface ErrorResponse {
    errors: string[];
}

apiClient.interceptors.response.use(
    (res) => res,
    (err: AxiosError<ErrorResponse>) => {
        if (err.response?.data?.errors?.length) {
            const errors = err.response.data.errors;
            const message = errors.join(', ') + '.';
            return Promise.reject(new Error(message));
        }

        return Promise.reject(err);
    }
);

export default apiClient;
